import { Autocomplete, AutocompleteProps, InputAdornment, Skeleton, TextField } from '@mui/material';
import { Icon, IconProps } from '@iconify/react';
import { FC } from 'react';

interface Item {
  label: string;
  value: string;
}

interface Props extends AutocompleteProps {
  items: Item[];
  label: string;
  loading?: boolean;
  fullWidth?: boolean;
  iconProps: IconProps;
  icon?: IconProps['icon'];
}

const SelectClinic: FC<Props> = ({ label, items, fullWidth, loading, iconProps, icon, ...props }) => {
  if (loading) return <Skeleton variant="rectangular" height={40} width={props?.sx?.width} />;
  return (
    <Autocomplete
      options={items}
      disabled={loading}
      loading={loading}
      autoHighlight
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth={fullWidth}
          size="small"
          label={label}
          value={props?.value || ''}
          slotProps={{
            input: {
              ...params.InputProps,
              ...(icon && {
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon height={24} color={loading ? undefined : `rgb(0, 119, 182)`} {...iconProps} icon={icon} />
                  </InputAdornment>
                ),
              }),
            },
          }}
        />
      )}
      {...props}
    ></Autocomplete>
  );
};

export default SelectClinic;
